import React from 'react';
import './Cutlery.less';
import {QuantityPicker} from "compositions/quantity-picker/QuantityPicker.tsx";

export const Cutlery = ({cutlery, onIncClick, onDecClick}) => {
	return (<div className="cutlery">
		<QuantityPicker
			value={cutlery}
			isPressed
			isBig
			onIncClick={onIncClick}
			onDecClick={onDecClick}
		/>
	</div>)
}
